<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h4>SSLMalta Statistics</h4>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12 mt-3">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <h4 class="my-auto text-primary pt-2"><i class="ti-user" aria-hidden="true"></i></h4>
              </div>
              <div class="col-md-6 text-left">
                <h4 class="my-auto text-primary pt-2"> Total Users</h4>
              </div>
              <div class="col-md-4 text-right">
                <h1 class="my-auto">{{customers.length}}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mt-3">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <h4 class="my-auto text-primary pt-2"><i class="fa fa-archive" aria-hidden="true"></i></h4>
              </div>
              <div class="col-md-6 text-left">
                <h4 class="my-auto text-primary pt-2">Total Items</h4>
              </div>
              <div class="col-md-4 text-right">
                <h1 class="my-auto">{{inventoryitems.length}}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mt-3">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <h4 class="my-auto text-primary pt-2"><i class="fa fa-hourglass-start" aria-hidden="true"></i></h4>
              </div>
              <div class="col-md-6 text-left">
                <h4 class="my-auto text-primary pt-2"> Total Quotes</h4>
              </div>
              <div class="col-md-4 text-right">
                <h1 class="my-auto">{{quotes.length}}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-md-4 col-12 mt-3">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <h4 class="my-auto text-success"><i class="fa fa-check-circle" aria-hidden="true"></i></h4>
              </div>
              <div class="col-md-6 text-left">
                <h4 class="my-auto text-success"> Completed Projects</h4>
              </div>
              <div class="col-md-4 text-right">
                <h1 class="my-auto">51</h1>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="row">
      <div class="col-md-6 col-12 mt-3">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <h4 class="my-auto text-primary pt-2"><i class="fa fa-briefcase" aria-hidden="true"></i></h4>
              </div>
              <div class="col-md-6 text-left">
                <h4 class="my-auto text-primary pt-2"> Total Categories</h4>
              </div>
              <div class="col-md-4 text-right">
                <h1 class="my-auto">{{categories.length}}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-3">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <h4 class="my-auto text-primary pt-2"><i class="fa fa-sitemap" aria-hidden="true"></i></h4>
              </div>
              <div class="col-md-6 text-left">
                <h4 class="my-auto text-primary pt-2">Sub Categories</h4>
              </div>
              <div class="col-md-4 text-right">
                <h1 class="my-auto">{{subcategories.length}}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <!-- <h4>Music Statistics</h4> -->
        <hr>
      </div>
    </div>

    
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  name: "Dashboard",
  computed:{
    ...mapGetters(['quotes','inventoryitems','customers','categories','subcategories'])
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      
    }
  }
};
</script>
<style scoped>
/* @import url('https://fonts.googleapis.com/css?family=Calistoga&display=swap');
h4 {
  font-family: 'Calistoga', cursive !important;
} */
.indigo {
  color: #6610f2;
}
.orange {
  color: #fd7e14;
}
.red {
  color: #dc3545;
}
.green {
  color: #28a745;
}
.blue-grey {
  color: #607D8B;
}

.teal {
  color: #009688;
}

.pink {
  color: #E91E63;
}

.amber {
  color: #FFC107;
}
</style>
